import { Collection1k04j3hzsbod0 as Collection } from '../collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { createCoroutineUninterceptedGeneratorVersion2gduom218i9ay as createCoroutineUninterceptedGeneratorVersion } from '../coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg2ei4op8d4d2m as _Result___get_value__impl__bjfvqg,
} from '../Result.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../coroutines/intrinsics/Intrinsics.mjs';
import { EmptyCoroutineContext_instance2qpebg1xogbvt as EmptyCoroutineContext_instance } from '../coroutines/CoroutineContextImpl.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../coroutines/Continuation.mjs';
import { Sequence1quqbxersk0bb as Sequence } from './Sequence.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function sequence(block) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (sequence$$inlined$Sequence$1())(block);
}
var SequenceScopeClass;
function SequenceScope() {
  if (SequenceScopeClass === VOID) {
    class $ {
      km(elements, $completion) {
        var tmp;
        if (isInterface(elements, Collection())) {
          tmp = elements.i1();
        } else {
          tmp = false;
        }
        if (tmp)
          return Unit_instance;
        return this.jm(elements.m1(), $completion);
      }
    }
    initMetadataForClass($, 'SequenceScope', VOID, VOID, VOID, [1]);
    SequenceScopeClass = $;
  }
  return SequenceScopeClass;
}
function iterator(block) {
  var iterator = new (SequenceBuilderIterator())();
  iterator.om_1 = createCoroutineUninterceptedGeneratorVersion(block, iterator, iterator);
  return iterator;
}
function nextNotReady($this) {
  if (!$this.n1())
    throw NoSuchElementException().y1();
  else
    return $this.o1();
}
function exceptionalState($this) {
  switch ($this.lm_1) {
    case 4:
      return NoSuchElementException().y1();
    case 5:
      return IllegalStateException().o4('Iterator has failed.');
    default:
      return IllegalStateException().o4('Unexpected state of the iterator: ' + $this.lm_1);
  }
}
var SequenceBuilderIteratorClass;
function SequenceBuilderIterator() {
  if (SequenceBuilderIteratorClass === VOID) {
    class $ extends SequenceScope() {
      constructor() {
        super();
        this.lm_1 = 0;
        this.mm_1 = null;
        this.nm_1 = null;
        this.om_1 = null;
      }
      n1() {
        while (true) {
          switch (this.lm_1) {
            case 0:
              break;
            case 1:
              if (ensureNotNull(this.nm_1).n1()) {
                this.lm_1 = 2;
                return true;
              } else {
                this.nm_1 = null;
              }

              break;
            case 4:
              return false;
            case 3:
            case 2:
              return true;
            default:
              throw exceptionalState(this);
          }
          this.lm_1 = 5;
          var step = ensureNotNull(this.om_1);
          this.om_1 = null;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
          step.rc(tmp$ret$0);
        }
      }
      o1() {
        switch (this.lm_1) {
          case 0:
          case 1:
            return nextNotReady(this);
          case 2:
            this.lm_1 = 1;
            return ensureNotNull(this.nm_1).o1();
          case 3:
            this.lm_1 = 0;
            var tmp = this.mm_1;
            var result = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
            this.mm_1 = null;
            return result;
          default:
            throw exceptionalState(this);
        }
      }
      q2(value, $completion) {
        this.mm_1 = value;
        this.lm_1 = 3;
        this.om_1 = $completion;
        return get_COROUTINE_SUSPENDED();
      }
      jm(iterator, $completion) {
        if (!iterator.n1())
          return Unit_instance;
        this.nm_1 = iterator;
        this.lm_1 = 2;
        this.om_1 = $completion;
        return get_COROUTINE_SUSPENDED();
      }
      pm(result) {
        // Inline function 'kotlin.getOrThrow' call
        throwOnFailure(result);
        var tmp = _Result___get_value__impl__bjfvqg(result);
        if (!(tmp == null ? true : !(tmp == null)))
          THROW_CCE();
        this.lm_1 = 4;
      }
      rc(result) {
        return this.pm(result);
      }
      pc() {
        return EmptyCoroutineContext_instance;
      }
    }
    initMetadataForClass($, 'SequenceBuilderIterator', SequenceBuilderIterator, VOID, [SequenceScope(), Continuation()], [1]);
    SequenceBuilderIteratorClass = $;
  }
  return SequenceBuilderIteratorClass;
}
var sequence$$inlined$Sequence$1Class;
function sequence$$inlined$Sequence$1() {
  if (sequence$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($block) {
        this.qm_1 = $block;
      }
      m1() {
        return iterator(this.qm_1);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Sequence()]);
    sequence$$inlined$Sequence$1Class = $;
  }
  return sequence$$inlined$Sequence$1Class;
}
//region block: exports
export {
  SequenceScope as SequenceScope1coiso86pqzq2,
  iterator as iterator3f5i676wpaa3g,
  sequence as sequence2vgswtrxvqoa7,
};
//endregion

//# sourceMappingURL=SequenceBuilder.mjs.map
